<template>
    <Flash v-if="showFlash" alert="success">Stationery request submitted successfully.</Flash>
    <div class="bg-white">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
                <h1 v-if="state == 'future'" class="h4 mb-0">Upcoming Stationery Requests</h1>
                <h1 v-if="state == 'past'" class="h4 mb-0">Historical Stationery Requests</h1>
            </div>

            <div>
                <router-link class="btn btn-primary" :to="{ name: 'StationeryCreate' }">Request Stationery</router-link>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col">
                <strong>Requester</strong>
            </div>
            <div class="col">
                <strong>Type</strong>
            </div>
            <div class="col">
                <strong>Requested</strong>
            </div>
            <div class="col" v-if="state == 'past'">
                <strong>Completed</strong>
            </div>
        </div>

        <ul v-if="filteredOrders.length" class="order-list mb-4">
            <li v-for="order in filteredOrders" :key="order.stationery_request_id">
                <div class="row align-items-center">
                    <div class="col">{{ order.dentist && order.dentist.first_name }} {{ order.dentist && order.dentist.surname }}</div>
                    <div class="col">
                        <span v-for="(item, index) in order.items" :key="item.id">
                            {{ item.typeLabel }}<span v-if="index < order.items.length - 1">, </span>
                        </span>
                    </div>
                    <div class="col">{{ $filters.formatDate(order.created_at) }}</div>
                    <div class="col" v-if="state == 'past'">{{ order.completed_at ? $filters.formatDate(order.completed_at) : '-' }}</div>
                </div>
            </li>
        </ul>
        <div v-else>
            No Stationery Requests
        </div>
    </div>
</template>

<style scoped lang="scss">
    .order-list
    {
        list-style: none;
        padding: 0px;
        margin: 0px;

        > li
        {
            border-top: 1px solid #EEEEEE;
            padding: 10px 0px;

            strong
            {
                color: $swift-dark-grey;
            }
        }
    }
</style>

<script>
    import api from '@/services/api';
    import Flash from '@/components/Flash.vue';

    export default {
        components: {
            Flash,
        },
        props: {
            state: {
                default: 'future',
            },
        },
        data() {
            return {
                orders: [],
                showFlash: false,
            }
        },
        computed: {
            filteredOrders() {
                if (this.state == 'past') {
                    return this.orders.filter(o => !!o.completed_at);
                }
                return this.orders.filter(o => !o.completed_at);
            },
        },
        mounted() {
            this.fetchOrders();
        },
        watch: {
            '$store.state.currentPracticeId': function() {
                this.fetchOrders();
            },
            state() {
                this.fetchOrders();
            },
        },
        methods: {
            fetchOrders() {
                if (!this.$store.state.currentPracticeId) {
                    this.orders = [];
                    return;
                }
                api
                .get('/api/v1/stationery/recent-orders', {
                    params: {
                        practice_id: this.$store.state.currentPracticeId,
                        state: this.state,
                    }
                })
                .then((response) => {
                    this.orders = response.data;
                })
                .catch((error) => {
                    console.log('Catch stationery orders error:', error);
                });
            },
        },
    }
</script>
